export default __webpack_public_path__ + "static/media/ag-solar-logo.b0fb2364.png";